<template>
  <v-card>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 class="headline">Delete Batch and its allocation lines?</v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="close()" :color="primaryGrey">Close</v-btn>
      <v-btn flat @click="deleteBatch()" color="red darken-1" :loading="loading">Delete</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import AllocationService from "@/services/requests/allocationService";
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    deleteBatch() {
      this.loading = true;
      AllocationService.deleteBatch(this.batch)
        .then(result => {
          this.loading = false;
          console.log(result);
          this.snack({ text: "Batch was deleted!", color: "yellow" });
          this.close();
          this.fetchBatches = true;
        })
        .catch(err => {
          this.loading = false;
          this.snack({ text: err.response.data.message, color: "red" });
        });
    },
    close() {
      this.$emit("close");
    }
  },
  computed: {
    fetchBatches: Store.getSet({
      store: "allocationStaging",
      prop: "fetchBatches"
    })
  },
  props: {
    batch: Object
  }
};
</script>